import React from 'react'
import { FadeLoader } from 'react-spinners';

const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    zIndex: 9999,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };
const LoadingCommon = ({statusLoading}) => {

  return (
   <>
    {statusLoading && (
        <div style={overlayStyle}>
          <FadeLoader color="#3534ff" />
        </div>
      )}
   </>
  )
}

export default LoadingCommon